import { ReactComponent as ArrowSVG } from "images/arrowUpRight.svg"
import UniversalLink from "library/Loader/UniversalLink"
import { ScreenContext } from "library/ScreenContext"
import { fmobile, fresponsive, ftablet } from "library/fullyResponsive"
import { useContext } from "react"
import styled, { css } from "styled-components"
import colors from "styles/colors"

export default function OrgCard({
	logo,
	name,
	url,
}: {
	logo: string
	name: string
	url: string
}) {
	const { mobile } = useContext(ScreenContext)

	return (
		<Wrapper to={url} ariaLabel={`Visit ${name}`}>
			{!mobile && (
				<Border
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 265 128"
					fill="none"
				>
					<path
						d="M0.50415 10C0.50415 4.7533 4.75745 0.5 10.0042 0.5H62.5576H255.004C260.251 0.5 264.504 4.75329 264.504 10V70C264.504 75.2467 260.251 79.5 255.004 79.5H227.004C221.205 79.5 216.504 84.201 216.504 90V118C216.504 123.247 212.251 127.5 207.004 127.5H10.0042C4.75745 127.5 0.50415 123.247 0.50415 118V10Z"
						fill="#F5F5FA"
						stroke="#E0E0EB"
					/>
				</Border>
			)}
			{mobile && (
				<LogoWrapper>
					<Logo src={logo} alt={name} />
				</LogoWrapper>
			)}

			{!mobile && (
				<>
					<ArrowButton>
						<Arrow />
					</ArrowButton>
					<Logo src={logo} alt={name} />
				</>
			)}
		</Wrapper>
	)
}

const Wrapper = styled(UniversalLink)`
	${fresponsive(css`
		width: 265px;
		position: relative;
		display: block;
	`)}
	${ftablet(css`
		width: 300px;
	`)}
	${fmobile(css`
		width: 111px;
		height: 92px;
	`)}
`

const LogoWrapper = styled.div`
	border: 1px solid ${colors.grey1};
	display: grid;
	place-items: center;

	${fmobile(css`
		width: 111px;
		height: 92px;
		border-radius: 8px;
	`)}
`

const Border = styled.svg`
	display: block;
	width: 100%;
`

const ArrowButton = styled.div`
	${fresponsive(css`
		background: ${colors.blue2};
		display: flex;
		width: 40px;
		height: 40px;
		justify-content: center;
		border-radius: 8px;
		align-items: center;
		position: absolute;
		bottom: 0;
		right: 0;
	`)}

	${ftablet(css`
		width: 45px;
		height: 45px;
	`)}
`

const Arrow = styled(ArrowSVG)`
	${fresponsive(css`
		width: 10px;
		height: 10px;
		transition: rotate 0.3s ease-in-out;
	`)}

	${ftablet(css`
		width: 12px;
		height: 12px;
	`)}


  path {
		stroke: white;
	}

	${Wrapper}:hover & {
		rotate: 45deg;
	}
`

const Logo = styled.img`
	${fresponsive(css`
		position: absolute;
		top: 32px;
		left: 52px;
		width: 152px;
		height: 60px;
	`)}

	${ftablet(css`
		top: 37px;
		left: 58px;
		width: 172px;
		height: 68px;
	`)}

  ${fmobile(css`
		position: relative;
		top: unset;
		left: unset;
		width: 76px;
		height: 30px;
	`)}
`
